import React from "react";
import PropTypes from "prop-types";
import FormRow from "../HorizontalForm/FormRow";

/**
 * Just overrides the standard form row to align the label above the input
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
const StackedFormRow = (props) => {
    return (
        <FormRow
            leftCellClassName={props.cellClassName}
            rightCellClassName={props.cellClassName}
            labelClassName={props.labelClassName}
            {...props}
        />
    )
}

StackedFormRow.propTypes = {
    label: PropTypes.string,
    errorMessage: PropTypes.string,
    required: PropTypes.bool,
    className: PropTypes.string,
    cellClassName: PropTypes.string,
    labelClassName: PropTypes.string,
    tooltip: PropTypes.string,
    infoMessage: PropTypes.string,
    disabled: PropTypes.bool,
}

StackedFormRow.defaultProps = {
    className: '',
    cellClassName: 'small-12',
    labelClassName: '',
    disabled: false,
}

export default StackedFormRow;
